import { selectIsSessionActive, selectIsWindowOpen, selectIsWebRtcOwner, useNicStore } from 'stores/nic/stores/nicStore';
import { selectCalls, useCallStore } from 'stores/nic/stores/callStore';
/**
 * Reads the NIC session/call state the window renders from, collapsing the calls
 * array down to the one call in flight. Keeps the store wiring out of the
 * component, which only needs the flags below.
 */
export var useNicWindowSession = function () {
    var _a, _b, _c;
    var isSessionActive = useNicStore(selectIsSessionActive);
    var isWindowOpen = useNicStore(selectIsWindowOpen);
    var isWebRtcOwner = useNicStore(selectIsWebRtcOwner);
    var setIsWindowOpen = useNicStore(function (state) { return state.setWindowOpen; });
    var calls = useCallStore(selectCalls);
    var hasActiveCall = useCallStore(function (state) { return state.hasActiveCall; });
    var currentCallIndex = calls.findIndex(function (c) { return c.call !== null; });
    var currentCall = (_a = calls[currentCallIndex]) === null || _a === void 0 ? void 0 : _a.call;
    var isOnHold = (_c = (_b = calls[currentCallIndex]) === null || _b === void 0 ? void 0 : _b.isOnHold) !== null && _c !== void 0 ? _c : false;
    return {
        isSessionActive: isSessionActive,
        isWindowOpen: isWindowOpen,
        isWebRtcOwner: isWebRtcOwner,
        setIsWindowOpen: setIsWindowOpen,
        hasActiveCall: hasActiveCall,
        currentCall: currentCall,
        isOnHold: isOnHold
    };
};
